import {
  createUserWithEmailAndPassword,
  GoogleAuthProvider,
  onAuthStateChanged,
  sendPasswordResetEmail,
  signInWithEmailAndPassword,
  signInWithPopup,
  signOut,
  type User
} from "firebase/auth";
import { httpsCallable } from "firebase/functions";
import { auth, functions } from "./firebase";
import { bootstrapMasterClient } from "./bootstrap";

export function observeAuth(callback: (user: User | null) => void): () => void {
  if (!auth) {
    callback(null);
    return () => undefined;
  }

  return onAuthStateChanged(auth, callback);
}

export async function signInWithGoogle(): Promise<User> {
  if (!auth) {
    throw new Error("Firebase nao configurado. Verifique o arquivo .env.");
  }

  const provider = new GoogleAuthProvider();
  provider.setCustomParameters({ prompt: "select_account" });
  try {
    const credential = await signInWithPopup(auth, provider);
    return credential.user;
  } catch (error) {
    const code = typeof error === "object" && error && "code" in error ? String(error.code) : "";
    if (code === "auth/unauthorized-domain") {
      throw new Error("Dominio nao autorizado no Firebase Authentication. Adicione este dominio em Authentication > Settings > Authorized domains.");
    }

    throw error;
  }
}

export async function signInWithEmail(email: string, password: string): Promise<User> {
  if (!auth) {
    throw new Error("Firebase nao configurado. Verifique o arquivo .env.");
  }

  const credential = await signInWithEmailAndPassword(auth, email, password);
  return credential.user;
}

export async function createAccountWithEmail(email: string, password: string): Promise<User> {
  if (!auth) {
    throw new Error("Firebase nao configurado. Verifique o arquivo .env.");
  }

  const credential = await createUserWithEmailAndPassword(auth, email, password);
  return credential.user;
}

export async function sendPasswordReset(email: string): Promise<void> {
  if (!auth) {
    throw new Error("Firebase nao configurado. Verifique o arquivo .env.");
  }

  await sendPasswordResetEmail(auth, email);
}

export async function signOutUser(): Promise<void> {
  if (!auth) {
    return;
  }

  await signOut(auth);
}

export async function bootstrapMaster(user: User): Promise<void> {
  if (!functions) {
    await bootstrapMasterClient(user);
    return;
  }

  const callable = httpsCallable(functions, "bootstrapMaster");
  try {
    await callable();
  } catch (error) {
    console.warn("Bootstrap via Function falhou; tentando bootstrap inicial via Firestore Rules.", error);
    await bootstrapMasterClient(user);
  }
}
